import React from 'react';
import PropTypes from 'prop-types';
import { Block, Link, Navbar, NavRight, Page, Popup } from 'framework7-react';
import II18 from '../translate/II18';
import { getIcon } from '../helpers/utils';

export function getInstallGuideInfo() {
  const userAgent = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const isSamsungBrowser = /SamsungBrowser/i.test(userAgent);
  const isFirefox = /Firefox|FxiOS/i.test(userAgent);

  if (isIOS) {
    return {
      title: II18.get('pwa_install_guide_ios_title'),
      steps: [
        {
          text: II18.get('pwa_install_guide_ios_step_1'),
          imageSrc: '/pwa-install-ios-step-1.png'
        },
        {
          text: II18.get('pwa_install_guide_ios_step_2'),
          imageSrc: '/pwa-install-ios-step-2.png'
        },
        {
          text: II18.get('pwa_install_guide_ios_step_3'),
          imageSrc: '/pwa-install-ios-step-3.png'
        }
      ]
    };
  }

  if (isAndroid && isSamsungBrowser) {
    return {
      title: II18.get('pwa_install_guide_android_title'),
      steps: [
        {
          text: II18.get('pwa_install_guide_samsung_step_1'),
          imageSrc: '/pwa-install-android-step-1.png'
        },
        {
          text: II18.get('pwa_install_guide_samsung_step_2'),
          imageSrc: '/pwa-install-android-step-2.png'
        },
        {
          text: II18.get('pwa_install_guide_samsung_step_3'),
          imageSrc: '/pwa-install-android-step-3.png'
        }
      ]
    };
  }

  if (isAndroid && isFirefox) {
    return {
      title: II18.get('pwa_install_guide_android_title'),
      steps: [
        {
          text: II18.get('pwa_install_guide_firefox_android_step_1'),
          imageSrc: '/pwa-install-android-step-1.png'
        },
        {
          text: II18.get('pwa_install_guide_firefox_android_step_2'),
          imageSrc: '/pwa-install-android-step-2.png'
        },
        {
          text: II18.get('pwa_install_guide_firefox_android_step_3'),
          imageSrc: '/pwa-install-android-step-3.png'
        }
      ]
    };
  }

  if (isAndroid) {
    return {
      title: II18.get('pwa_install_guide_android_title'),
      steps: [
        {
          text: II18.get('pwa_install_guide_android_step_1'),
          imageSrc: '/pwa-install-android-step-1.png'
        },
        {
          text: II18.get('pwa_install_guide_android_step_2'),
          imageSrc: '/pwa-install-android-step-2.png'
        },
        {
          text: II18.get('pwa_install_guide_android_step_3'),
          imageSrc: '/pwa-install-android-step-3.png'
        }
      ]
    };
  }

  return {
    title: II18.get('pwa_install_guide_default_title'),
    steps: [
      {
        text: II18.get('pwa_install_guide_default_step_1'),
        imageSrc: '/pwa-install-android-step-1.png'
      },
      {
        text: II18.get('pwa_install_guide_default_step_2'),
        imageSrc: '/pwa-install-android-step-2.png'
      },
      {
        text: II18.get('pwa_install_guide_default_step_3'),
        imageSrc: '/pwa-install-android-step-3.png'
      }
    ]
  };
}

function InstallUserGuid({ opened, onClose }) {
  const guide = getInstallGuideInfo();

  return (
    <Popup
      id={'install_user_guid_popup'}
      className="install-user-guid-popup"
      opened={Boolean(opened)}
      swipeToClose={false}
      onPopupClosed={onClose}
    >
      <Page>
        <Navbar title={II18.get('pwa_install_guide_popup_title')}>
          <NavRight>
            <Link popupClose>{II18.get('title_close')}</Link>
          </NavRight>
        </Navbar>
        <Block>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 20,
              borderRadius: 10,
              background: '#92ccff',
              padding: '0 15px'
            }}
          >
            {getIcon('f7:square_arrow_down', 25)}
            <h3>{guide.title}</h3>
          </p>
          <p style={{ fontSize: 16 }}>{II18.get('pwa_install_guide_intro')}</p>
          <ol style={{ fontSize: 16 }}>
            {guide.steps.map(step => (
              <li
                key={`${step.imageSrc}-${step.text}`}
                style={{ marginBottom: 20 }}
              >
                {step.text}
                <img
                  src={step.imageSrc}
                  alt=""
                  loading="lazy"
                  style={{
                    width: '100%',
                    maxWidth: 360,
                    height: 'auto',
                    display: 'block',
                    margin: '8px auto',
                    borderRadius: 10
                  }}
                />
              </li>
            ))}
          </ol>
        </Block>
      </Page>
    </Popup>
  );
}

InstallUserGuid.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func
};

export default InstallUserGuid;
